const slugPattern = /[^a-z0-9]+/g;

export const slugifyRouteValue = (value: string): string => {
    const normalized = (value || '').toLowerCase().trim();
    const slug = normalized.replace(slugPattern, '-').replace(/^-+|-+$/g, '');
    return slug || 'item';
};

export const isUuid = (value: string): boolean => {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
};

